import BaseRepository from '@/repository/BaseRepository'
import { getStoredEndDate, getStoredStartDate } from '@/lib/localStorage'
import type {
  RepartitionSuiviCommandeViewModel,
  suiviCommandesSettings,
  GetSuiviCommandeViewModel,
} from '@/lib/types'

export default {
  async getInfoCardData(): Promise<GetSuiviCommandeViewModel> {
    const url = await BaseRepository.buildUrl(
      `api/widgets/card-suivi-commandes/?date_debut=${getStoredStartDate()}&date_fin=${getStoredEndDate()}`,
    )
    return BaseRepository.fetchData<GetSuiviCommandeViewModel>(url)
  },

  async getRepartitionData(): Promise<RepartitionSuiviCommandeViewModel[]> {
    const url = await BaseRepository.buildUrl(
      `api/widgets/card-repartition-suivi-commandes/?date_debut=${getStoredStartDate()}&date_fin=${getStoredEndDate()}`,
    )
    return BaseRepository.fetchData<RepartitionSuiviCommandeViewModel[]>(url)
  },

  async getSettings(): Promise<suiviCommandesSettings> {
    return BaseRepository.fetchData<suiviCommandesSettings>(
      await BaseRepository.buildUrl('api/widgets/card-suivi-commandes/settings'),
    )
  },
}
